import { CommonOrderWorkType } from "./CommonOrderWorkType";

enum SpecificLogisticsOrderWorkType {
    LOAD = "LOAD",
    UNLOAD = "UNLOAD",
}

export type LogisticsOrderWorkType = CommonOrderWorkType | SpecificLogisticsOrderWorkType;
export const LogisticsOrderWorkType = { ...CommonOrderWorkType, ...SpecificLogisticsOrderWorkType };
